import { Facet } from '@ms/items-view/lib/private/models/Facet';
import {
  IListViewAdapter,
  IColumnAdapter,
  IRowAdapter,
  ICommandAdapter
} from '@ms/odsp-datasources/lib/interfaces/clientSideExtensions/ISpfxAdapter';
/**
 * Facet for client-side component id
 */
export const clientSideComponentIdFacet: Facet<string> = new Facet('clientSideComponentIdFacet');
/**
 * Facet for client-side component properties
 */
export const clientSideComponentPropertiesFacet: Facet<string> = new Facet('clientSideComponentPropertiesFacet');
/**
 * Facet for client-side listview adapter
 */
export const listViewAdapterFacet: Facet<IListViewAdapter> = new Facet('listViewAdapterFacet');
/**
 * Facet for client-side column adapter
 */
export const columnAdapterFacet: Facet<IColumnAdapter> = new Facet('columnAdapterFacet');
/**
 * Facet for client-side row adapter
 */
export const rowAdapterFacet: Facet<IRowAdapter> = new Facet('rowAdapterFacet');

/**
 * Facet for the key to the column adapter.
 */
export const columnAdapterKeyFacet: Facet<string> = new Facet('columnAdapterKey');

/**
 * Facet for the command adapter.
 */
export const commandAdapterFacet: Facet<ICommandAdapter> = new Facet('columnAdapterFacet');

/**
 * observable facet to keep track of when SPFX application is loaded.
 */
export const isSpfxLoadedFacet: Facet<boolean> = new Facet('isSpfxLoadedFacet');
